




import {Component, Prop, Vue} from "vue-property-decorator";
import {RegionStore} from "../store";

@Component({
    name: "DistrictLabel"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly id!: number;

    get label() {
        return RegionStore.districtIdMapper[this.id]?.name;
    }
}
